import { atom } from 'jotai'
import type { createStore } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'
import { hc, type InferResponseType } from 'hono/client'
import type { ComponentDetailApi } from '@backend/api/stores/ComponentDetailStore'
import { apiFetch } from '@paraflow-ai/frontend-libs'

type Store = ReturnType<typeof createStore>
const api = hc<ComponentDetailApi>('/api/stores/componentDetail', { fetch: apiFetch })

export const componentIdAtom = atom('')
export const activeTabAtom = atom<'design' | 'code' | 'props' | 'guidelines'>('design')

export const refreshAtom = atomWithQuery((get) => {
  const id = get(componentIdAtom)
  return {
    queryKey: ['ComponentDetailStore', id],
    queryFn: async () => {
      const res = await api.refresh.$get({ query: { id } })
      return await res.json()
    },
    enabled: !!id,
  }
})

export const updateAtom = atom(null, async (get, set, data: { name?: string; description?: string; categoryId?: string; status?: string; codeSnippet?: string; propsDoc?: string; guidelines?: string; tags?: string }) => {
  const id = get(componentIdAtom)
  await api.update.$post({ json: { id, ...data } })
  await get(refreshAtom).refetch()
})

export const archiveAtom = atom(null, async (get) => {
  const id = get(componentIdAtom)
  await api.archive.$post({ json: { id } })
  await get(refreshAtom).refetch()
})

export function loader(store: Store, params: { id?: string }) {
  const id = params.id!
  store.set(componentIdAtom, id)
  store.set(activeTabAtom, 'design')
  store.get(refreshAtom)
  return null
}
